import type { IPublicClientApplication } from "@azure/msal-browser";
import type { AuthenticationResult } from "@azure/msal-common";
import type { Result } from "common/utils/result";

export async function MSALLoginPopup(
  MSALInstance: IPublicClientApplication,
  userId: string,
): Promise<Result<AuthenticationResult>> {
  MSALInstance.setActiveAccount(null);

  try {
    return await MSALInstance.loginPopup({
      scopes: ["user.read"],
      prompt: "login",
      loginHint: userId,
    });
  } catch (error) {
    if (error instanceof Error) {
      return error;
    }

    return new Error("An error occurred with the MSAL authentication");
  }
}
